module.exports = __webpack_public_path__ + "img/downarrow.cee189d0.svg";